import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  card: {
    width: '100%',
    background: theme.palette.common.white,
    padding: 24,
    borderRadius: 8,
    marginBottom: 16,
    boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.12), 0px 0px 0px 1px rgba(19, 45, 74, 0.04)',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      background: theme.palette.common.white,
      padding: '24px 24px 32px',
      boxShadow: 'none',
      marginBottom: '0px !important',
    },
  },
  containerAvatar: {
    paddingTop: 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      paddingTop: 16,
    },
  },
  agentAvatar: {
    display: 'flex',
    alignItems: 'center',
  },
  avatar: {
    padding: 8,
  },
  agentInformation: {
    display: 'flex',
    marginLeft: 16,
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  agentText: {
    display: 'flex',
    alignItems: 'center',
  },
  agentName: {
    color: theme.palette.primary.dark,
    paddingRight: 4,
  },
  agentPhone: {
    color: theme.palette.secondary.main,
  },
}))
